import styled from 'styled-components'

import { Cores } from '../styles/cores'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Filtro = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const OpcaoFiltro = styled.button<{ ativo: boolean }>`
  padding: 4px 12px;
  border-radius: 14px;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid
    ${({ ativo }) => (ativo ? Cores.PRIMARIA_2 : Cores.CINZA_1_CLARO)};
  background-color: ${({ ativo }) =>
    ativo ? Cores.PRIMARIA_2 : Cores.BRANCO};
  color: ${({ ativo }) => (ativo ? Cores.BRANCO : Cores.CINZA_1)};
`

export const Timeline = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`

export const ItemTimeline = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 2px 0 2px 14px;
  border-left: 2px solid ${Cores.PRIMARIA_2};

  .titulo {
    font-size: 14px;
    font-weight: 500;
    color: ${Cores.CINZA_1};
  }

  .contexto {
    font-weight: 400;
    color: ${Cores.CINZA_2};
  }

  .meta {
    font-size: 11px;
    color: ${Cores.CINZA_2_CLARO};
  }

  .alteracao {
    font-size: 13px;
    color: ${Cores.CINZA_1};
  }

  .observacao {
    margin-top: 4px;
    padding: 8px 10px;
    border-radius: 6px;
    background-color: ${Cores.CINZA_3_MAIS_CLARO};
    font-size: 13px;
    color: ${Cores.CINZA_1};
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
`

export const TagCategoria = styled.span`
  align-self: flex-start;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  color: ${Cores.PRIMARIA_2_CLARO};
  background-color: ${Cores.CINZA_3_MAIS_CLARO};
  border: 1px solid ${Cores.PRIMARIA_2};
`

export const Mensagem = styled.div`
  font-size: 14px;
  color: ${Cores.CINZA_2};
`

export const AcoesRodape = styled.div`
  display: flex;
  justify-content: center;
`

export const NotaInicio = styled.p`
  margin: 0;
  font-size: 12px;
  color: ${Cores.CINZA_2_CLARO};
`
